const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the comment configuration component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('commentConfiguration', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        instructions: '=',
        onChange: '&?',
        type: '=?'
      },
      template: require('../../../templates/directives/cms/comment-configuration.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.typeKeys = {
          'file': 'global.contentTypes.file',
          'article': 'global.contentTypes.article',
          'video': 'global.contentTypes.video',
          'track': 'global.contentTypes.track',
          'imported': 'global.contentTypes.imported',
          'workshop': 'global.contentTypes.workshop',
          'scorm': 'global.contentTypes.scorm'
        };
        self.type = self.typeKeys[$scope.type] ? self.typeKeys[$scope.type] : 'content';
        self.triggerChange = function() {
          if (!$scope.onChange) {
            return;
          }
          $scope.onChange();
        }
      }],
      controllerAs: 'comments'
    };
  }]);
